$(document).ready(function() {
  $('.anoucement-slide').css('opacity', 1);
$('.anoucement-slide').slick({
  dots: false,
  infinite: true,
  speed: 300,
  prevArrow: `<button type="button" class="slick-prev">
    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.539029 9.51618L8.48557 17.0877C8.61816 17.2141 8.79432 17.2846 8.9775 17.2846C9.16069 17.2846 9.33685 17.2141 9.46944 17.0877L9.47799 17.0791C9.5425 17.0179 9.59386 16.9441 9.62895 16.8624C9.66405 16.7806 9.68215 16.6926 9.68215 16.6036C9.68215 16.5146 9.66405 16.4266 9.62895 16.3449C9.59386 16.2631 9.5425 16.1893 9.47799 16.1281L1.99487 8.99857L9.47799 1.87193C9.5425 1.81065 9.59386 1.73689 9.62895 1.65514C9.66405 1.57339 9.68215 1.48536 9.68215 1.39639C9.68215 1.30742 9.66405 1.21939 9.62895 1.13764C9.59386 1.05589 9.5425 0.982128 9.47799 0.920853L9.46944 0.912296C9.33685 0.785898 9.16069 0.715385 8.9775 0.715385C8.79432 0.715385 8.61816 0.785898 8.48557 0.912296L0.539029 8.48382C0.469142 8.55041 0.413505 8.63049 0.375489 8.71922C0.337473 8.80795 0.317871 8.90347 0.317871 9C0.317871 9.09653 0.337473 9.19205 0.375489 9.28078C0.413505 9.36951 0.469142 9.44959 0.539029 9.51618Z" fill="black"/>
    </svg>
  </button>`,
  nextArrow: `<button type="button" class="slick-next">
    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.46097 9.51618L1.51443 17.0877C1.38184 17.2141 1.20568 17.2846 1.0225 17.2846C0.83931 17.2846 0.663153 17.2141 0.530561 17.0877L0.522005 17.0791C0.457504 17.0179 0.406144 16.9441 0.371047 16.8624C0.335951 16.7806 0.317852 16.6926 0.317852 16.6036C0.317852 16.5146 0.335951 16.4266 0.371047 16.3449C0.406144 16.2631 0.457504 16.1893 0.522005 16.1281L8.00513 8.99857L0.522005 1.87193C0.457504 1.81065 0.406144 1.73689 0.371047 1.65514C0.335951 1.57339 0.317852 1.48536 0.317852 1.39639C0.317852 1.30742 0.335951 1.21939 0.371047 1.13764C0.406144 1.05589 0.457504 0.982128 0.522005 0.920853L0.530561 0.912296C0.663153 0.785898 0.83931 0.715385 1.0225 0.715385C1.20568 0.715385 1.38184 0.785898 1.51443 0.912296L9.46097 8.48382C9.53086 8.55041 9.5865 8.63049 9.62451 8.71922C9.66253 8.80795 9.68213 8.90347 9.68213 9C9.68213 9.09653 9.66253 9.19205 9.62451 9.28078C9.5865 9.36951 9.53086 9.44959 9.46097 9.51618Z" fill="black"/>
    </svg>
  </button>`,
  slidesToShow: 1,
  slidesToScroll: 1,
  
  responsive: [
    {
      breakpoint: 1024,
      settings: {
     slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
$('.collection-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  prevArrow: `<button type="button" class="slick-prev">
    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.539029 9.51618L8.48557 17.0877C8.61816 17.2141 8.79432 17.2846 8.9775 17.2846C9.16069 17.2846 9.33685 17.2141 9.46944 17.0877L9.47799 17.0791C9.5425 17.0179 9.59386 16.9441 9.62895 16.8624C9.66405 16.7806 9.68215 16.6926 9.68215 16.6036C9.68215 16.5146 9.66405 16.4266 9.62895 16.3449C9.59386 16.2631 9.5425 16.1893 9.47799 16.1281L1.99487 8.99857L9.47799 1.87193C9.5425 1.81065 9.59386 1.73689 9.62895 1.65514C9.66405 1.57339 9.68215 1.48536 9.68215 1.39639C9.68215 1.30742 9.66405 1.21939 9.62895 1.13764C9.59386 1.05589 9.5425 0.982128 9.47799 0.920853L9.46944 0.912296C9.33685 0.785898 9.16069 0.715385 8.9775 0.715385C8.79432 0.715385 8.61816 0.785898 8.48557 0.912296L0.539029 8.48382C0.469142 8.55041 0.413505 8.63049 0.375489 8.71922C0.337473 8.80795 0.317871 8.90347 0.317871 9C0.317871 9.09653 0.337473 9.19205 0.375489 9.28078C0.413505 9.36951 0.469142 9.44959 0.539029 9.51618Z" fill="black"/>
    </svg>
  </button>`,
  nextArrow: `<button type="button" class="slick-next">
    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.46097 9.51618L1.51443 17.0877C1.38184 17.2141 1.20568 17.2846 1.0225 17.2846C0.83931 17.2846 0.663153 17.2141 0.530561 17.0877L0.522005 17.0791C0.457504 17.0179 0.406144 16.9441 0.371047 16.8624C0.335951 16.7806 0.317852 16.6926 0.317852 16.6036C0.317852 16.5146 0.335951 16.4266 0.371047 16.3449C0.406144 16.2631 0.457504 16.1893 0.522005 16.1281L8.00513 8.99857L0.522005 1.87193C0.457504 1.81065 0.406144 1.73689 0.371047 1.65514C0.335951 1.57339 0.317852 1.48536 0.317852 1.39639C0.317852 1.30742 0.335951 1.21939 0.371047 1.13764C0.406144 1.05589 0.457504 0.982128 0.522005 0.920853L0.530561 0.912296C0.663153 0.785898 0.83931 0.715385 1.0225 0.715385C1.20568 0.715385 1.38184 0.785898 1.51443 0.912296L9.46097 8.48382C9.53086 8.55041 9.5865 8.63049 9.62451 8.71922C9.66253 8.80795 9.68213 8.90347 9.68213 9C9.68213 9.09653 9.66253 9.19205 9.62451 9.28078C9.5865 9.36951 9.53086 9.44959 9.46097 9.51618Z" fill="black"/>
    </svg>
  </button>`,
  slidesToShow: 4,
  slidesToScroll: 1,
  
  responsive: [
    {
      breakpoint: 1024,
      settings: {
     slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow:2,
        slidesToScroll: 1
      }
    }
  ]
});
 $('.product__accordion details').on('toggle', function() {
    var $this = $(this);

    if ($this.prop('open')) {
      $('.product__accordion details').not($this).removeAttr('open');
    }
  });


  $('.accordion details').on('toggle', function() {
    var $this = $(this);

    if ($this.prop('open')) {
      // Close all other accordions
      $('.accordion details').not($this).removeAttr('open');
      
      // Update aria-expanded attributes
      $('.accordion summary').attr('aria-expanded', false);
      $this.find('summary').attr('aria-expanded', true);
    } else {
      // If closed, set aria-expanded to false
      $this.find('summary').attr('aria-expanded', false);
    }
  });


  // Select the dots element
  var $dots = $('.slider-counter--dots');
  
  // Move it outside the buttons container (after it)
  $dots.insertAfter($('.slideshow__controls'));

});
